/* global jQuery */

import 'bootstrap-sass/assets/javascripts/bootstrap/transition';
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';

import './navbar';
import './scrollto';
import './projects';
import './clients';
import './awards';
import './swiper';
import './noVideo';

import '../scss/style.scss';

const toTop = document.querySelector('.back-to-top');
const menuModal = document.querySelector('#modal-menu');
const navbar = document.querySelector('.navbar');

if (document.querySelector('body.home')) {
  const fancyText = document.querySelector('.ultimate-typewriter-suffix');

  if (fancyText) {
    fancyText.innerHTML = fancyText.textContent.replace(/\./, '.<br>');
  }
}

window.addEventListener('scroll', () => {
  if (window.scrollY > 300) {
    toTop.classList.add('show');
  } else {
    toTop.classList.remove('show');
  }
});

jQuery(menuModal).on('show.bs.modal shown.bs.modal', () => {
  navbar.classList.add('invert');
});

jQuery(menuModal).on('hide.bs.modal hidden.bs.modal', () => {
  navbar.classList.remove('invert');
});



// WEBPACK FOOTER //
// ./scripts/main.js